"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigate = void 0;
var computeUrl_1 = require("./computeUrl");
function detectReplace(url) {
    return location.href === url.href;
}
function navigate(pathOrUrl, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var url = computeUrl_1.computeUrl(pathOrUrl);
    if (url.origin !== location.origin) {
        window.location.href = url.href;
        return;
    }
    var urlWithoutOrigin = url.href.substr(url.origin.length);
    var replace = (_a = options.replace) !== null && _a !== void 0 ? _a : detectReplace(url);
    if (replace)
        window.history.replaceState(null, "", urlWithoutOrigin);
    else
        window.history.pushState(null, "", urlWithoutOrigin);
    window.dispatchEvent(new PopStateEvent("popstate"));
}
exports.navigate = navigate;
//# sourceMappingURL=navigate.js.map